import React from 'react';
import './About.css';

const About = () => {
    const teamMembers = [
        {
            name: "Alex Thompson",
            role: "Chief Executive Officer",
            bio: "Visionary leader with 15+ years of experience in technology and business strategy.",
            image: "👨‍💼"
        },
        {
            name: "Maria Garcia",
            role: "Chief Technology Officer",
            bio: "Expert in software architecture and emerging technologies with a passion for innovation.",
            image: "👩‍💻"
        },
        {
            name: "David Kim",
            role: "Head of Product",
            bio: "Product strategist focused on creating user-centric solutions that drive business value.",
            image: "👨‍🎨"
        },
        {
            name: "Sarah Wilson",
            role: "VP of Customer Success",
            bio: "Dedicated to ensuring our clients achieve their goals and maximize their investment.",
            image: "👩‍💼"
        }
    ];

    const milestones = [
        {
            year: "2018",
            title: "Company Founded",
            description: "Started with a vision to transform how businesses operate through technology."
        },
        {
            year: "2019",
            title: "First Major Client",
            description: "Successfully implemented our solution for a Fortune 500 company."
        },
        {
            year: "2021",
            title: "Series A Funding",
            description: "Raised $10M to accelerate product development and market expansion."
        },
        {
            year: "2023",
            title: "Global Expansion",
            description: "Opened offices in Europe and Asia to serve our growing international client base."
        },
        {
            year: "2024",
            title: "AI Integration",
            description: "Launched AI-powered features to enhance automation and insights."
        }
    ];

    const values = [
        {
            title: "Innovation",
            description: "We constantly push boundaries to deliver cutting-edge solutions.",
            icon: "💡"
        },
        {
            title: "Integrity",
            description: "We build trust through transparency and ethical business practices.",
            icon: "🤝"
        },
        {
            title: "Excellence",
            description: "We strive for perfection in everything we do, from code to customer service.",
            icon: "⭐"
        },
        {
            title: "Collaboration",
            description: "We believe great things happen when talented people work together.",
            icon: "🤝"
        }
    ];

    return (
        <div className="about-container">
            <div className="about-hero">
                <h1>About Our Company</h1>
                <p>Empowering businesses through innovative technology solutions since 2018</p>
            </div>

            <div className="about-story">
                <div className="story-content">
                    <h2>Our Story</h2>
                    <p>
                        Founded in 2018 by a team of passionate technologists, our company emerged from a simple yet powerful idea: 
                        technology should make business operations simpler, not more complex. We started in a small garage with big dreams 
                        and an unwavering commitment to helping businesses thrive in the digital age.
                    </p>
                    <p>
                        Today, we serve hundreds of clients worldwide, from startups to Fortune 500 companies, providing them with 
                        the tools and expertise they need to stay competitive in an ever-evolving marketplace. Our journey has been 
                        marked by continuous innovation, strategic partnerships, and most importantly, the success of our clients.
                    </p>
                </div>
                <div className="story-stats">
                    <div className="stat">
                        <h3>500+</h3>
                        <p>Happy Clients</p>
                    </div>
                    <div className="stat">
                        <h3>50+</h3>
                        <p>Team Members</p>
                    </div>
                    <div className="stat">
                        <h3>15+</h3>
                        <p>Countries Served</p>
                    </div>
                    <div className="stat">
                        <h3>99.9%</h3>
                        <p>Uptime</p>
                    </div>
                </div>
            </div>

            <div className="values-section">
                <h2>Our Values</h2>
                <div className="values-grid">
                    {values.map((value, index) => (
                        <div key={index} className="value-card">
                            <div className="value-icon">{value.icon}</div>
                            <h3>{value.title}</h3>
                            <p>{value.description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="timeline-section">
                <h2>Our Journey</h2>
                <div className="timeline">
                    {milestones.map((milestone, index) => (
                        <div key={index} className="timeline-item">
                            <div className="timeline-year">{milestone.year}</div>
                            <div className="timeline-content">
                                <h3>{milestone.title}</h3>
                                <p>{milestone.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div className="team-section">
                <h2>Meet Our Leadership Team</h2>
                <div className="team-grid">
                    {teamMembers.map((member, index) => (
                        <div key={index} className="team-card">
                            <div className="team-avatar">{member.image}</div>
                            <h3>{member.name}</h3>
                            <h4>{member.role}</h4>
                            <p>{member.bio}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="about-cta">
                <h2>Want to Learn More?</h2>
                <p>Get in touch with us to discover how we can help your business succeed.</p>
                <button className="contact-cta">Contact Us Today</button>
            </div>
        </div>
    );
};

export default About;
